import {
  Box,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button as MuiButton,
} from "@mui/material";
import RestoreIcon from "@mui/icons-material/Restore";
import React from "react";
import { Button, ButtonVariantOption } from "@/components/Button";
import { SizingWrapperStyle } from "@/components/Wrapper";
import type { AdditionalFieldItem } from "@/features/accountSettings/types/additionalFields";
import { getFieldTypeLabel } from "../constants";

interface DeletedFieldsModalProps {
  open: boolean;
  deletedFields: AdditionalFieldItem[];
  onRestore: (index: number) => void;
  onClose: () => void;
}

/**
 * 削除済み項目表示モーダルコンポーネント
 */
export const DeletedFieldsModal: React.FC<DeletedFieldsModalProps> = ({
  open,
  deletedFields,
  onRestore,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>削除済み項目</DialogTitle>
      <DialogContent>
        {deletedFields.length === 0 ? (
          <Box sx={{ py: 2 }}>削除済み項目はありません</Box>
        ) : (
          <Box sx={{ py: 1 }}>
            {deletedFields.map((field, index) => {
              const fieldTypeLabel = getFieldTypeLabel(field.fieldType);

              return (
                <Box
                  key={field.id || `field-${index}`}
                  sx={{
                    mb: 1,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 1,
                    p: 1,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 1,
                    mr: 1,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <span>{field.key}</span>
                    <Chip label={fieldTypeLabel} size="small" />
                  </Box>
                  <MuiButton
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      onRestore(index);
                    }}
                    startIcon={<RestoreIcon />}
                  >
                    復元
                  </MuiButton>
                </Box>
              );
            })}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          label="閉じる"
          variant={ButtonVariantOption.Outlined}
          size={SizingWrapperStyle.SMALL}
          onClick={onClose}
        />
      </DialogActions>
    </Dialog>
  );
};
